import { Applications } from './Applications';
export class PlatformPrivateServices {
    constructor(ds, hostAPI, events, experimentsAPI, manifestsManager, editorPointerAPI) {
        this.ds = ds;
        this.hostAPI = hostAPI;
        this.events = events;
        this.experimentsAPI = experimentsAPI;
        this.manifestsManager = manifestsManager;
        this.editorPointerAPI = editorPointerAPI;
        this.apps = new Applications(this.events);
    }
}
//# sourceMappingURL=PlatformPrivateServices.js.map